import React, { useState, useEffect } from 'react';
import { frontendDb as db } from '../lib/frontend-db';
import Header from './Header';
import Footer from './Footer';

const Imprint = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    loadImprint();
  }, []);

  const loadImprint = async () => {
    try {
      const imprint = await db.getImprint();
      if (imprint) {
        setContent(imprint.content);
      } else {
        setError('Keine Impressumsdaten gefunden.');
      }
    } catch (error) {
      console.error('Error loading imprint:', error);
      setError('Fehler beim Laden des Impressums. Bitte versuch es später erneut.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-white dark:bg-gray-950 transition-colors duration-300">
        <Header />
        <main className="container mx-auto px-4 py-16 mt-16">
          <div className="max-w-3xl mx-auto">
            <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/4 mb-4 animate-pulse" />
            <div className="space-y-4">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
              ))}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-white dark:bg-gray-950 transition-colors duration-300">
        <Header />
        <main className="container mx-auto px-4 py-16 mt-16">
          <div className="max-w-3xl mx-auto">
            <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-6 text-center">
              <h2 className="text-xl font-semibold text-red-800 mb-2">Fehler</h2>
              <p className="text-red-600 dark:text-red-400">{error}</p>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 transition-colors duration-300">
      <Header />
      <main className="container mx-auto px-4 py-16 mt-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-[var(--primary-color)] mb-8">Impressum</h1>
          <div className="prose max-w-none">
            {content.split('\n').map((paragraph, index) => (
              <p key={index} className="mb-2 text-gray-700 dark:text-gray-200 leading-snug min-h-[1.5em]">
                {paragraph || '\u00A0'}
              </p>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Imprint;

